<template>
	 <v-container>
		 <v-dialog title="修改学员信息" v-model="hideShow" width="600px" persistent>
			<v-card>
				<v-card-title>
					<span>修改学员信息</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-6">
					<v-row dense v-if="update.student">
						<v-col cols="6">
							<v-text-field label="学员姓名" v-model="update.student.studentName" dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="6" class="mt-n2">
							<v-radio-group label="性别:" v-model="update.student.gender" row>
								<v-radio label="男生" value="1"></v-radio>
								<v-radio label="女生" value="0"></v-radio>
							</v-radio-group>
						</v-col>
						
						<v-col cols="6">
							<v-text-field label="联系人关系" v-model="update.student.contactorCall" dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="联系人手机" v-model="update.student.contactorMobile" dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="6" class="d-flex">
							<v-select v-model="update.student.studentSource" :items="studentSourceItems" label="生源类型" item-text="sourceName"
								item-value="id" outlined dense></v-select>
							<v-btn color="info" small class="ml-1 mt-1" @click="showCreateSource('1')">添加</v-btn>
						</v-col>
						<v-col cols="12">
							<span style="color:red;">以下为选填项目:</span>
						</v-col>
						
						<v-col cols="4">
							<v-menu ref="menuBirthday2" v-model="update.menuBirthday" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="update.student.birthday" label="学员生日" readonly v-bind="attrs"
										v-on="on" dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="update.student.birthday" @input="update.menuBirthday=false"
									locale="zh-cn" no-title scrollable>
								</v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="8">
							<!-- 上传图片组件 -->
							<cutImageUpload :show="hideShow" title="修改学员头像" :previewImg="update.student.avatar" :waterText="update.student.studentName" @success="uploadSuccess"></cutImageUpload>
						</v-col>
							<v-col cols="6" class="d-flex">
							<v-select v-model="update.student.fromSchool" :items="fromSchoolItems" label="就读学校" item-text="sourceName"
								item-value="id" outlined dense></v-select>
							<v-btn color="info" small class="ml-1 mt-1" @click="showCreateSource('2')">添加</v-btn>
						</v-col>
						<v-col cols="6" class="d-flex">
							<v-select v-model="update.student.fromRegion" :items="fromRegionItems" label="居住片区" item-text="sourceName"
								item-value="id" outlined dense></v-select>
							<v-btn color="info" small class="ml-1 mt-1" @click="showCreateSource('3')">添加</v-btn>
						</v-col>
						<v-col cols="6">
							<v-text-field label="身份证号" v-model="update.student.idCardNo" dense outlined>
							</v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="家庭住址" v-model="update.student.homeAddress" dense outlined>
							</v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitUpdate" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- 添加生源组件 -->
		<createStudentSource :show="createSourceShow" :dataType="createSourceDataType" @cancel="createSourceShow=false" @success="createSourceSuccess"></createStudentSource>
	 </v-container>
</template>

<script>
	import utils from "../config/utils"
	import uploadPhoto from "./upload_photo.vue"
	import createStudentSource from "./create_student_source.vue"
	import cutImageUpload from "./cut_image_upload.vue"
	export default {
		name:"update-student",
		components:{uploadPhoto,createStudentSource,cutImageUpload},
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			student:{
				type:Object,
				default:null
			},
		},
		watch:{
			show(newVal,oldVal){
				this.hideShow = newVal;
				console.log("update student show=",newVal);
				if(this.hideShow){
					
					console.log(this.student);
					
					this.update.student.id = this.student.id;
					this.update.student.studentName = this.student.studentName;
					this.update.student.gender = this.student.gender;
					this.update.student.birthday = this.student.birthday;
					this.update.student.avatar = this.student.avatar;
					this.update.student.contactorCall = this.student.contactorCall;
					this.update.student.contactorMobile = this.student.contactorMobile;
					this.update.student.homeAddress = this.student.homeAddress;
					this.update.student.studentSource = this.student.studentSource;
					this.update.student.fromSchool = this.student.fromSchool;
					this.update.student.fromRegion = this.student.fromRegion;
					this.update.student.idCardNo = this.student.idCardNo;
					

				}
				
			}
		},
		data(){
			return {
				shopId:"",
				update: {
					menuBirthday: false,
					student:{
						id: "",
						studentName: "",
						gender: "",
						avatar: "",
						birthday: "",
						contactorCall: "",
						contactorMobile: "",
						homeAddress: "",
						studentSource:"",
						fromSchool:"",
						fromRegion:"",
						idCardNo:""
					},
				},
				hideShow:this.show,
				studentSourceItems:[],
				createSourceShow:false,
				createSourceDataType:"",
				fromSchoolItems:[],
				fromRegionItems:[]
				
			}
		},
		mounted() {
			this.shopId = utils.getCurrentShopId();
			//this.getShopListForSelect();
			console.log("update-student mounted");
			this.getStudentSourceList('1');
			this.getStudentSourceList('2');
			this.getStudentSourceList('3');
		},
		methods:{
			uploadSuccess(e){
				console.log("修改学员头像成功",e);
				this.update.student.avatar = e.key;
			},
			
			submitUpdate() {
			
				if (!this.update.student.studentName) {
					this.$noty.error('姓名不能为空');
					return
				}
				if (!this.update.student.gender) {
					this.$noty.error('性别不能为空');
					return
				}
		
				// api
				const that = this;
				let url = `/edu/student/update`;
			
				// parameters
				const updateData = {
					...this.update.student
				}

				this.axios.post(url, updateData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							
							that.$emit("success","");
							
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
			
				});
			},
			cancel(){
				this.$emit("cancel","");
			},
			getStudentSourceList(dataType){
				
				// api
				const that = this;
				let url = `/edu/shop/student/source/list/${this.shopId}/${dataType}`;	
				this.axios.get(url).catch(() => {
					
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							
							const result = res.data["data"]||[];
							
							if (dataType=='1'){
								that.studentSourceItems = result;
							}else if (dataType=='2'){
								that.fromSchoolItems = result;
							}else if (dataType=='3'){
								that.fromRegionItems = result;
							}
							
							return;
						} 
					} 
							
				});
			},
			showCreateSource(dataType){
				this.createSourceDataType = dataType;
				this.createSourceShow = true;
			},
			createSourceSuccess(){
				this.getStudentSourceList(this.createSourceDataType);
				this.createSourceShow = false;
			}
		}
	}
	
</script>

<style>
</style>
